<template>
	<header class="console-header">
		<div class="console-header__left">
			<app-logo></app-logo>
			<nav class="console-header__tabs">
				<button
					v-for="tab in topTabs"
					:key="tab.routeName || tab.section || tab.label"
					:class="{ active: isActiveTab(tab), locked: tab.requiresAuth && !isAuthenticated }"
					@click="handleTabClick(tab)"
				>
					{{ tab.label }}
				</button>
			</nav>
		</div>

		<div class="console-header__actions">
			<app-header-account-sets v-if="showFinanceContext"></app-header-account-sets>
			<div class="console-header__period" v-if="showFinanceContext">{{ accountDate }}</div>
			<template v-if="isAuthenticated">
				<DropdownMenu className="console-user-dropdown" trigger="click" :width="160" placement="bottom-end" :datas="infoMenu" @onclick="trigger">
					<div class="console-header__user">
						<span class="console-header__name">{{ userName }}</span>
						<i class="fa fa-angle-down"></i>
					</div>
				</DropdownMenu>
			</template>
			<template v-else>
				<Button size="s" @click="goLogin">登录</Button>
			</template>
		</div>
	</header>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import { getTopTabs } from '../../js/config/site-nav';
import AppHeaderAccountSets from './modules/app-header-account-sets';
import AppLogo from './app-logo';

export default {
	name: 'AppHeader',
	components: {
		AppHeaderAccountSets,
		AppLogo
	},
	data() {
		return {
			topTabs: getTopTabs(),
			infoMenu: [
				{ key: 'info', title: '个人信息', icon: 'h-icon-user' },
				{ key: 'logout', title: '退出登录', icon: 'h-icon-outbox' }
			]
		};
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		...mapGetters(['isAuthenticated']),
		showFinanceContext() {
			return this.isAuthenticated && this.currentAccountSets && this.$route.meta && this.$route.meta.section === 'finance';
		},
		accountDate() {
			return this.currentAccountSets
				? moment(this.currentAccountSets.currentAccountDate).format('YYYY年第MM期')
				: '';
		},
		userName() {
			if (!this.User) {
				return '';
			}
			return this.User.realName || this.User.nickname || this.User.mobile || '未登录';
		}
	},
	methods: {
		isActiveTab(tab) {
			if (tab.comingSoon) {
				return false;
			}
			if (tab.section === 'finance') {
				return this.$route.meta.section === 'finance';
			}
			return this.$route.name === tab.routeName || this.$route.meta.section === tab.section;
		},
		handleTabClick(tab) {
			if (tab.requiresAuth && !this.isAuthenticated) {
				this.goLogin(tab.routeName);
				return;
			}
			if (tab.comingSoon) {
				this.$Message.info('暂未开通');
				return;
			}
			this.$router.push({ name: tab.routeName });
		},
		goLogin(routeName) {
			const target = routeName ? this.$router.resolve({ name: routeName }).href : this.$route.fullPath;
			this.$router.push({
				name: 'Login',
				query: {
					redirect: target
				}
			});
		},
		trigger(data) {
			if (data === 'logout') {
				this.$store.dispatch('logout').finally(() => {
					this.$router.replace({ name: 'Login' });
				});
				return;
			}
			this.$router.push({ name: 'PersonalSetting' });
		}
	}
};
</script>
